// console.log("Script has been loaded...");
// window.onload = function() {
//  let myiFrame = document.getElementById("qontak-webchat-widget");
//  let doc = myiFrame.contentWindow.document.body.innerHTML;
//  setTimeout(function () {
//    console.log(doc)
//  }, 5000)
// }
setTimeout(function (evt) {
    $(".qchat-button").click(function (e) {
        // console.log(e);
    });
    //   console.log('timeout qchat-button')
}, 5000);
$(document).ready(function () {
    // promo payday
    if ($(".payday-voucher").length) {
        $("#claim-pv").click(function () {
            let postUrl = "https://member-id.devbdd.com/member/voucher_claim";
            let dataToPost = {
                shop: Shopify.shop,
                phone: pv_customer_phone,
                code: promo_code,
                id: pv_customer_id,
            };

            $.ajax({
                type: "GET",
                url: postUrl,
                data: dataToPost,
                beforeSend: function () {
                    $("#claim-pv").attr("disabled", true).html("Wait...");
                },
                success: function (response) {
                    let data = JSON.parse(response);

                    if (data["kode"] == 1) {
                        $("body").append(`
                            <div class="pv-popup">
                                <div class="pv-popup-inner">
                                    <div class="pv-popup-box">
                                        <div class="pv-header">
                                            <h3>Success Claim</h3>
                                            <span class="pv-close">×</span>
                                        </div>
                                        <div class="pv-body">
                                            <div class="pv-voucher-detail">
                                                <h2 class="pvv-name">${promo_code}</h2>
                                                <button class="pvv-button pvv-button-popup" id="copy-vp">Copy</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `);

                        setTimeout(() => {
                            $(".pv-popup").addClass("active");
                            $("#claim-pv").removeAttr("disabled").html("Claim");
                            $("#slider-popup").appendTo(".pv-body");
                            $("#slider-popup").css({
                                height: "auto",
                                opacity: "1",
                            });
                        }, 500);
                    } else {
                        $("#claim-pv").removeAttr("disabled").html("Claim");
                        alert(data["msg"]);
                    }
                },
            });
        });

        $(document).on("click", ".pv-close", function () {
            $(".pv-popup").removeClass("active");
        });

        $(document).on("click", "#copy-vp", function () {
            var textToCopy = promo_code;
            var tempTextarea = $("<textarea>");
            $("body").append(tempTextarea);
            tempTextarea.val(textToCopy).select();
            document.execCommand("copy");
            tempTextarea.remove();

            $("#copy-vp").html("Copied!");
            setTimeout(() => {
                $("#copy-vp").html("Copy");
            }, 3000);
        });
    }

    // upcoming page
    if ($("body").hasClass("template-upcoming")) {
        $(document).on("click", "#openForm", function (e) {
            e.preventDefault();
            $("body").css("overflow", "hidden");
            $(".popup-form").show();
            $(".upcoming-floating").addClass("hidefloating");
        });

        $(document).on("click", ".form-close .close", function (e) {
            e.preventDefault();
            $("body").css("overflow", "");
            $(".popup-form").hide();
            $(".upcoming-floating").removeClass("hidefloating");
        });

        $("#enterForm").on("click", function (e) {
            e.preventDefault();
            console.log(e);
            $("body").css("overflow", "hidden");
            $(".popup-form").show();
            $(".upcoming-floating").addClass("hidefloating");
        });

        function showFloatingDraw() {
            const floatingElement =
                document.querySelector(".upcoming-floating");
            if (window.scrollY > 300) {
                floatingElement.style.transform = "translateY(0)";
            } else {
                floatingElement.style.transform = "";
            }
        }

        window.addEventListener("scroll", showFloatingDraw);
        window.addEventListener("load", showFloatingDraw);

        $(".form-product-register").on("submit", function (e) {
            e.preventDefault();
            let url =
                "https://atmos-custom-plugin-front.devbdd.com/api/customers/submit";
            let name = $("[name=name]").val() ? $("[name=name]").val() : "";
            let email = $("[name=email]").val() ? $("[name=email]").val() : "";
            let phone = $("[name=phone]").val() ? $("[name=phone]").val() : "";
            let product_id = $("#product_id").val();

            let jsonData = {
                url_shopify: Shopify.shop,
                id_form: 2,
                ktp: 0,
                receipt_number: 0,
                product: product_id,
                name: name,
                email: email,
                phone: phone,
                ig: null,
                shoe_size: null,
                address: null,
                birtday: null,
            };

            console.log(jsonData);

            $.ajax({
                url: "https://atmos-custom-plugin-front.devbdd.com/api/customers/submit",
                type: "POST",
                data: jsonData, // Include data in the request
                dataType: "json",
                crossDomain: true, // Enable CORS
                beforeSend: function () {
                    $(".form-content-submit .form-submit")
                        .html(`Loading...`)
                        .attr("disabled", "disabled");
                },
                success: function (data) {
                    $(".form-content-submit .form-submit")
                        .html(`Submit`)
                        .removeAttr("disabled");
                    let result = data.response;

                    if (result["status"] == "200") {
                        // alert("Successfully submitted");
                        $(".form-response")
                            .html("Thankyou for your submit.")
                            .css("text-align", "center");
                        // location.reload();
                    } else {
                        alert("Already submitted");
                    }
                },
                error: function (xhr, status, error) {
                    console.log(error, xhr, status);
                },
            });
        });
    }

    // sidebar drawer

    // function open sidebar menu
    $("#new-main-nav-toggle, #search-sidebar-button").click(function (e) {
        if ($(this).attr("aria-click") == "false") {
            if ($(".btn-cart").hasClass("active")) {
                $(".btn-cart").trigger("click");
            }

            $(".account-header").removeClass("show");
            $("section.cart-section").show();
            $(".account-header-close").hide();

            $("#new-main-nav-toggle").attr("aria-click", "true");
            $("#search-sidebar-button").attr("aria-click", "true");
            $("#search-sidebar-button").hide();

            if ($(".site-header-container").hasClass("fixed")) {
                $("#melissa-sidebar").css({ top: "68px" });
            } else {
                $("#melissa-sidebar").removeAttr("style");
            }

            $("#melissa-sidebar").attr("aria-sidebar", "opened");
            // $('.body-overlay').addClass('is-visible');
            $("body").attr("style", "overflow: hidden;");
            $(".filter-sticky").css("z-index", "1");
            // $(".site-header-container").addClass('fixed');
            $(".site-header-container").css({ "background-color": "#FFF8FC" });
        } else {
            $("#new-main-nav-toggle").attr("aria-click", "false");
            $("#search-sidebar-button").attr("aria-click", "false");
            $("#search-sidebar-button").show();

            $("#melissa-sidebar").attr("aria-sidebar", "closed");
            // $('.body-overlay').removeClass('is-visible');
            $("body").attr("style", "");
            $(".filter-sticky").css("z-index", "0");
            // $(".site-header-container").addClass('fixed')
            $(".site-header-container").removeAttr("style");
        }
    });

    // function close sidebar menu
    $("#close-sidebar").click(function (e) {
        if ($(this).attr("aria-click") == "false") {
            console.log("closed");
            $("#melissa-sidebar").attr("aria-sidebar", "closed");
            $("#new-main-nav-toggle").attr("aria-click", "false");
            $("#search-sidebar-button").attr("aria-click", "false");
            // $('.body-overlay').removeClass('is-visible');
            $("body").attr("style", "");
            setTimeout(() => {
                $(".filter-sticky").css("z-index", "");
            }, 500);
        }
    });

    // sidebar collapsible button
    $(".sidebar-collapsible--button").click(function (e) {
        e.preventDefault();
        let panel = this.nextElementSibling;
        if ($(this).attr("aria-expanded") == "false") {
            $(this).attr("aria-expanded", "true");
            if (!panel.style.maxHeight) {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        } else {
            $(this).attr("aria-expanded", "false");
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            }
        }
    });

    // form login page

    // forgot password
    $("#forgot-password-link").click(function (e) {
        e.preventDefault();
        $("#recover-customer-password").removeClass("hidden");
        $("#customer-login").toggleClass("hidden");
    });

    // back to login form
    $("#back-to-login-link").click(function (e) {
        e.preventDefault();
        $("#recover-customer-password").toggleClass("hidden");
        $("#customer-login").removeClass("hidden");
    });

    $("#to").on("change keyup keydown", function () {
        $.post("/cart.js", {
            attributes: {
                To: $(this).val(),
            },
        }).done(function () {});
    });
    $("#from").on("change keyup keydown", function () {
        $.post("/cart.js", {
            attributes: {
                From: $(this).val(),
            },
        }).done(function () {});
    });
    $("#greetings").on("change keyup keydown", function () {
        $.post("/cart.js", {
            attributes: {
                Greetings: $(this).val(),
            },
        }).done(function () {});
    });
    $("#notes").on("change keyup keydown", function () {
        $.post("/cart.js", {
            attributes: {
                Notes: $(this).val(),
            },
        }).done(function () {});
    });
    // $(".installment-detailna").fancybox({
    // 	maxWidth: 800,
    // 	touch: false,
    // 	clickSlide: false,
    // 	overlay: {
    // 		locked: false,
    // 		clickSlide: false
    // 	},
    // 	keys: {
    // 		close: null
    // 	}
    // });

    if ($(".banner-collection-slider").length) {
        $(".banner-collection-slider").owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            items: 1,
            navText: [
                "<div class='nav-btn prev-slide'></div>",
                "<div class='nav-btn next-slide'></div>",
            ],
            autoplay: true,
            autoplayTimeout: 2000,
            autoplayHoverPause: false,
        });
    }

    var discount_redeem = localStorage.getItem("redeem_discount");
    var checkout_url = "/checkout";
    if (discount_redeem) {
        //$("#checkout-button").attr("href","/cart?discount="+discount_redeem);
        $(".cart-action-buttons .row .text-right").html(
            `
      <a href="/checkout?discount=` +
                discount_redeem +
                `" id="checkout-with-discount"><i class="cart-loader fa fa-spinner fa-spin"></i> Checkout →</a>
      `
        );
        checkout_url = "/checkout?discount=" + discount_redeem;
    }
    var installment_provider = $("#payment-provider .payment-item");
    for (let i = 0; i < installment_provider.length; i++) {
        // console.log(i);
        $(".payment-item[data-index=" + i + "]").click(function () {
            $(".payment-item").removeClass("payment-selected");
            $(".payment-item[data-index=" + i + "]").addClass(
                "payment-selected"
            );
            var get_payment = $(
                ".installment-label[data-index=" + i + "]"
            ).attr("data-payment");
            $(".installment-label").hide();
            $(".installment-label[data-index=" + i + "]").show();
        });
    }
    $(".collection-wrapper").owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        navText: [
            "<div class='nav-btn prev-slide'></div>",
            "<div class='nav-btn next-slide'></div>",
        ],
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: false,
        responsive: {
            0: {
                items: 2,
            },
            640: {
                items: 2,
            },
            1140: {
                items: 4,
            },
        },
    });
    $(".slide-promo").owlCarousel({
        loop: true,
        items: 1,
        autoplay: true,
        autoplayTimeout: 2500,
        autoplayHoverPause: false,
        dots: false,
        nav: false,
    });
    var acc = document.getElementsByClassName("filter-button");
    var i;
    // for (i = 0; i < acc.length; i++) {
    //     acc[i].addEventListener("click", function () {
    //         this.classList.toggle("filter-active");
    //         var panel = this.nextElementSibling;
    //         if (panel.style.maxHeight) {
    //             panel.style.maxHeight = null;
    //         } else {
    //             panel.style.maxHeight = "110" + "px";
    //         }
    //     });
    // }
    var filter_checkbox = $(".filter-item.category .filter-checkbox");
    for (let i = 0; i < filter_checkbox.length; i++) {
        var checkboxna = $(
            ".filter-item.category[data-index='" + i + "'] .filter-checkbox"
        );
        checkboxna.click(function () {
            if ($(this).is(":checked")) {
                location.href = $(this).attr("data-url");
            } else {
                parent.history.back();
                return false;
            }
        });
    }

    if (window.matchMedia("(max-width: 1024px)").matches) {
        $(".filter-toggle").click(function () {
            var $this = $(this);
            var filter_close_toggle = $(".filter-toggle-close");
            if ($this.attr("aria-clicked") == "false") {
                $this.attr("aria-clicked", "true");
                filter_close_toggle.attr("aria-closed", "false");
                $(".collection-sidebar-panel").show();
            }
        });
        $(".filter-toggle-close").click(function () {
            var $this = $(this);
            var filter_toggle = $(".filter-toggle");
            if ($this.attr("aria-closed") == "false") {
                $this.attr("aria-closed", "true");
                filter_toggle.attr("aria-clicked", "false");
                $(".collection-sidebar-panel").hide();
            }
        });
    } else {
        $(".filter-toggle").click(function () {
            $(".row-collection-product").toggleClass("filter-toggle-active");
            $(".columns-products").toggleClass("medium-10");
            $(".columns-products").toggleClass("medium-12");

            let top_filter_sticky = 104;
            // if ($('.row-collection-product').hasClass('filter-toggle-active')) {
            //     top_filter_sticky = parseFloat($('.filter-sticky').css('top'), 10)
            // }

            let height_header_bottom = $(
                ".collection-header-bottom"
            ).outerHeight();
            let default_height_header_bottom = 60;
            // console.log('top_filter_sticky', top_filter_sticky)
            // console.log('height_header_bottom', height_header_bottom)
            // console.log('default_height_header_bottom', default_height_header_bottom)

            let diff_height_size =
                height_header_bottom - default_height_header_bottom;
            // console.log('diff_height_size', diff_height_size)
            if (diff_height_size > 0) {
                $(".filter-sticky").css({
                    top: `${top_filter_sticky + diff_height_size}px`,
                });
                // console.log('top_filter_sticky + diff_height_size', top_filter_sticky + diff_height_size)
            }

            let params = new URLSearchParams(window.location.search);
            let product_grid = params.get("product-grid");

            if (product_grid) {
                if (product_grid == "5") {
                    $(".columns-products").toggleClass("medium-up-5");
                    $(".columns-products").toggleClass("medium-up-4");
                } else if (product_grid == "4") {
                    $(".columns-products").toggleClass("medium-up-4");
                    $(".columns-products").toggleClass("medium-up-3");
                }
            } else {
                $(".columns-products").toggleClass("medium-up-5");
                $(".columns-products").toggleClass("medium-up-4");
            }

            if ($(this).attr("aria-clicked") == "false") {
                $(this).attr("aria-clicked", "true");
            } else {
                $(this).attr("aria-clicked", "false");
            }

            setTimeout(function () {
                $(".column-banner-grid-odd").each(function (i, v) {
                    let height = $(v)
                        .prev()
                        .find(".product-list-item-2025")
                        .outerHeight();
                    $(v)
                        .find(".banner-list-image img")
                        .css({ "max-height": `${height}px` });
                });

                $(".column-banner-grid-even").each(function (i, v) {
                    let height = $(v)
                        .next()
                        .find(".product-list-item-2025")
                        .outerHeight();
                    $(v)
                        .find(".banner-list-image img")
                        .css({ "max-height": `${height}px` });
                });
            }, 300);

            $(".columns-products-nav").toggleClass("medium-10");
            $(".columns-products-nav").toggleClass("medium-12");
        });
    }

    var min = $('input[name="filter.v.price.gte"]').val();
    if (min == "") {
        min = 0;
    }
    var max = $('input[name="filter.v.price.lte"]').val();
    if (max == "") {
        max = $('input[name="filter.v.price.gte"]').attr("max");
    }
    var fixed_max = $('input[name="filter.v.price.gte"]').attr("max");
    var parts = window.location.href.split("?")[0].split("/");
    var lastSegment = parts.pop() || parts.pop(); // handle potential trailing slash
    var filter_item = $(".filter-item.cat");
    //   console.log(filter_item);
    if ($(".filter-item.cat").length > 0) {
        // console.log($('.filter-item.cat').children('.filter-cat').data('value'));
        // console.log($(".filter-item.cat .filter-cat[data-value=" + lastSegment + "]").data("value"),lastSegment);
        if (
            $(
                ".filter-item.cat .filter-cat[data-value=" + lastSegment + "]"
            ).data("value") == lastSegment
        ) {
            $(".filter-item.cat .filter-cat[data-value=" + lastSegment + "]")
                .prop("checked", true)
                .attr("disabled", true);
            $(".filter-item.cat .filter-cat[data-value=" + lastSegment + "]")
                .parent()
                .addClass("filter-selected");
            $(".filter-item.cat .filter-cat").parent().hide();
            $(".filter-item.cat .filter-cat[data-value=" + lastSegment + "]")
                .parent()
                .show();
        }
    }
    $(".filter-item.cat").click(function () {
        var click_value = $(this).children(".filter-cat").data("value");
        var new_url = lastSegment.replace(lastSegment, click_value);
        if (!$(this).children(".filter-cat").is(":checked")) {
            window.location.href = new_url;
        }
    });
    $(".filter-cat").change(function () {
        if (this.checked) {
            var click_value = $(this).data("value");
            var new_url = lastSegment.replace(lastSegment, click_value);
            window.location.href = new_url;
        }
    });
    // filtering
    $(".filter-checkbox")
        .off()
        .change(function () {
            var newURL = $(this).nextAll("a").attr("href");
            window.location.href = newURL;
        });
    const sortArray = (array) => {
        array = array.sort((a, b) => a - b);
        return array;
    };
    const groupBySizeRegion = (filters) => {
        let objectNumber = {};
        filters.forEach((filter) => {
            let splitFilter = filter.split(" "),
                sizeType =
                    splitFilter.length == 2
                        ? splitFilter[0]
                        : splitFilter.length == 3
                        ? `${splitFilter[0]} ${splitFilter[1]}`
                        : splitFilter.length == 1
                        ? `Size`
                        : null,
                sizeNumber =
                    splitFilter.length == 2
                        ? splitFilter[1]
                        : splitFilter.length == 3
                        ? splitFilter[2]
                        : splitFilter.length == 1
                        ? splitFilter[0]
                        : null;
            if (typeof objectNumber[sizeType] === "undefined") {
                objectNumber[sizeType] = [sizeNumber];
                // console.log(objectNumber[sizeType]);
            } else {
                objectNumber[sizeType] = [
                    ...objectNumber[sizeType],
                    sizeNumber,
                ];
                // console.log("else = " + sizeNumber);
            }
        });
        return objectNumber;
    };
    const getFilterWithLetter = (filters) => {
        filters = filters.filter((filter) => {
            let splitFilter = filter.split(" "),
                sizeNumber = parseFloat(splitFilter[1]);
            sizeNumber = splitFilter[1];
            // console.log(sizeNumber);
            if (sizeNumber != splitFilter[1]) return filter;
        });
        return filters;
    };
    const getFilterNumber = (filters) => {
        filters = filters.filter((filter) => {
            let splitFilter = filter.split(" "),
                sizeNumber = parseFloat(splitFilter[1]);
            sizeNumber = splitFilter[1];
            sizeNumber2 = splitFilter;
            // console.log(sizeNumber);
            if (sizeNumber == splitFilter[1]) {
                return filters;
            }
            if (sizeNumber2 == splitFilter[0]) {
                return filters;
            }
        });
        return filters;
    };
    const getSortedFilterNumber = (filterNumber) => {
        let objectNumber;
        if (filterNumber.length > 0) {
            objectNumber = groupBySizeRegion(filterNumber);
            for (item in objectNumber) {
                objectNumber[item] = objectNumber[item].map((val) => {
                    return val;
                });
                objectNumber[item] = sortArray(objectNumber[item]);
            }
            return objectNumber;
        }
    };
    const getSortedFilterWithLetter = (filterNumberLetter) => {
        let objectNumberLetter;
        if (filterNumberLetter.length > 0) {
            objectNumberLetter = groupBySizeRegion(filterNumberLetter);
            for (item in objectNumberLetter) {
                let newGroup = {};
                objectNumberLetter[item].forEach((val) => {
                    let lastChar = val[val.length],
                        isContainLetter = isNaN(parseFloat(lastChar))
                            ? true
                            : false;
                    if (isContainLetter) {
                        //       	newArray = [...newArray, [val.replace(lastChar, ""), lastChar]]
                        if (typeof newGroup[lastChar] === "undefined") {
                            newGroup[lastChar] = [val];
                        } else {
                            newGroup[lastChar] = [...newGroup[lastChar], val];
                        }
                    }
                });
                if (Object.keys(newGroup).length > 0) {
                    let keyLetter = [];
                    for (key in newGroup) {
                        keyLetter = [...keyLetter, key];
                    }
                    keyLetter.sort();
                    let sortNewGroup = {};
                    keyLetter.forEach((index) => {
                        sortNewGroup[index] = newGroup[index];
                    });
                    for (key in sortNewGroup) {
                        sortNewGroup[key] = sortNewGroup[key].map(
                            (valNewgroup) => {
                                let lastChar =
                                    valNewgroup[valNewgroup.length - 1];
                                return [
                                    valNewgroup.replace(lastChar, ""),
                                    lastChar,
                                ];
                            }
                        );
                        sortNewGroup[key] = sortNewGroup[key].sort(
                            (a, b) => parseFloat(a[0]) - parseFloat(b[0])
                        );
                        sortNewGroup[key] = sortNewGroup[key].map(
                            (valNewgroup) => {
                                let lastChar =
                                    valNewgroup[valNewgroup.length - 1];
                                return `${valNewgroup[0]}${valNewgroup[1]}`;
                            }
                        );
                    }
                    objectNumberLetter[item] = sortNewGroup;
                } else {
                    objectNumberLetter[item] = objectNumberLetter[item].map(
                        (val) => {
                            return parseFloat(val);
                        }
                    );
                    objectNumberLetter[item] = sortArray(
                        objectNumberLetter[item]
                    );
                }
            }
        }
        return objectNumberLetter;
    };
    const concatObject = (objectNumber, objectNumberLetter) => {
        if (typeof objectNumber !== "undefined") {
            if (Object.keys(objectNumber).length > 0) {
                for (key in objectNumber) {
                    if (typeof objectNumberLetter !== "undefined") {
                        if (Object.keys(objectNumberLetter).length > 0) {
                            for (index in objectNumberLetter) {
                                if (key === index) {
                                    if (
                                        Array.isArray(objectNumberLetter[index])
                                    ) {
                                        objectNumber[key] = objectNumber[
                                            key
                                        ].concat(objectNumberLetter[index]);
                                    } else {
                                        for (idx in objectNumberLetter[index]) {
                                            objectNumber[key] = objectNumber[
                                                key
                                            ].concat(
                                                objectNumberLetter[index][idx]
                                            );
                                        }
                                    }
                                } else {
                                    if (
                                        typeof objectNumber[index] ===
                                        "undefined"
                                    ) {
                                        objectNumber[index] =
                                            objectNumberLetter[index];
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else if (typeof objectNumberLetter !== "undefined") {
            if (Object.keys(objectNumberLetter).length > 0) {
                return objectNumberLetter;
            }
        }
        return objectNumber;
    };
    const appendFilter = (concatedObject, obj, sizeType, currentUrl) => {
        // console.log(sizeType);
        let objectHTML = concatedObject[obj].map((item) => {
            let itemUrl = item
                .toString()
                .replaceAll(" ", "-")
                .replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-");
            // console.log("item => " + item.toString());
            let filterHTML;
            if (obj == "BR") {
                filterHTML = `
                  <li class="filter-item size-digit-keatas size-${obj}-${item}">
                    <a href="${currentUrl}/size-${sizeType}-${itemUrl}-${
                    parseFloat(item) + 1
                }" title="Narrow selection to products matching tag size-${sizeType} ${item}/${
                    parseFloat(item) + 1
                }">${obj} ${item}/${parseFloat(item) + 1}</a>    
                  </li>	
              `;
            } else {
                if (sizeType.toLowerCase() != "size") {
                    filterHTML = `
                    <li class="filter-item size-digit-keatas size-${obj}-${item}">
                        <a href="${currentUrl}/size-${sizeType}-${itemUrl}" title="Narrow selection to products matching tag size-${sizeType} ${item}">${sizeType} ${item}</a>    
                    </li>
                `;
                } else {
                    if (item != 0) {
                        filterHTML = `
                    <li class="filter-item size-digit-keatas selain-size tesss">
                        <a href="${currentUrl}/size-${itemUrl}" title="Narrow selection to products matching tag size ${item}">${item}</a>    
                    </li>	
                `;
                    }
                }
            }
            return filterHTML;
        });
        return objectHTML;
    };
    let currentUrl =
            location.protocol + "//" + location.host + location.pathname,
        currentUrlSplit = currentUrl.split("/");
    currentUrl =
        currentUrlSplit.length > 5
            ? location.protocol +
              "//" +
              location.host +
              "/" +
              currentUrlSplit[3] +
              "/" +
              currentUrlSplit[4]
            : currentUrl;
    if (
        location.pathname.includes("collections") &&
        !location.pathname.includes("products")
    ) {
        let filters = [];
        size.forEach((val) => {
            filters = [...filters, val];
        });
        filters = filters.map((item) => {
            if (item.split("-") > 1) {
                return `Size ${item}`;
            } else {
                return item;
            }
        });
        let filterNumber = getFilterNumber(filters);
        let filterNumberLetter = getFilterWithLetter(filters);
        let objectNumber = getSortedFilterNumber(filterNumber);
        let objectNumberLetter = getSortedFilterWithLetter(filterNumberLetter);
        let concatedObject = concatObject(objectNumber, objectNumberLetter);
        for (obj in concatedObject) {
            let sizeType = obj
                    .replaceAll(" ", "-")
                    .replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-"),
                objectHTML;
            if (Array.isArray(concatedObject[obj])) {
                objectHTML = appendFilter(
                    concatedObject,
                    obj,
                    sizeType,
                    currentUrl
                );
                //   console.log(obj)
                let containerFilterHTML = `
          <ul class="filter-list 2digit_keatas duakeatas type-${obj.toLowerCase()}">
              ${objectHTML.join("\n")}
          </ul>
        `;
                $("#sizeFilterna .filter-panel").append(containerFilterHTML);
            } else {
                for (key in concatedObject[obj]) {
                    objectHTML = concatedObject[obj][key].map((item) => {
                        let itemUrl = item
                            .toString()
                            .replaceAll(" ", "-")
                            .replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-");
                        let filterHTML;
                        if (obj == "BR") {
                            filterHTML = `
                    <li class="filter-item size-digit-keatas size-${item}">
                      <a href="${currentUrl}/size-${sizeType}-${itemUrl}-${
                                parseFloat(item) + 1
                            }" title="Narrow selection to products matching tag size-${sizeType} ${item}/${
                                parseFloat(item) + 1
                            }">${obj} ${item}/${parseFloat(item) + 1}</a>    
                    </li>	
                `;
                        } else if (obj == "NS") {
                            // console.log("tesss");
                        } else {
                            if (sizeType.toLowerCase() != "size") {
                                filterHTML = `
                      <li class="filter-item size-digit-keatas size-${item}">
                          <a href="${currentUrl}/size-${sizeType}-${itemUrl}" title="Narrow selection to products matching tag size-${sizeType} ${item}">${obj} ${item}</a>    
                      </li>	
                  `;
                            } else {
                                if (item != 0) {
                                    filterHTML = `
                      <li class="filter-item size-digit-keatas selain-size">
                          <a href="${currentUrl}/size-${itemUrl}" title="Narrow selection to products matching tag size ${item}">${obj} ${item}</a>    
                      </li>	
                  `;
                                    // console.log("tessss");
                                }
                            }
                        }
                        return filterHTML;
                    });
                    let containerFilterHTML = `
          <ul class="filter-list 2digit_kebawah duakeatas type-${obj.toLowerCase()}">
              ${objectHTML.join("\n")}
          </ul>
          `;
                    $("#filterClothing .filter-panel .filter-list").append(
                        `${objectHTML.join("\n")}`
                    );
                }
            }
        }
    }
    url = window.location.href;
    is_product = url.match(/.*\/products\/.*/);
    // console.log(url, is_product);
    if (
        window.location.href.includes("collections") ||
        $("body").hasClass("template-special-page")
    ) {
        if (is_product == null) {
            document
                .querySelector("#SortBy")
                .addEventListener("change", function () {
                    const urlSearchParams = new URLSearchParams(
                        window.location.search
                    );
                    urlSearchParams.set(this.name, this.value);
                    window.location = `?${urlSearchParams}`;
                });

            var announce_height = $("#shopify-section-promo-bar").outerHeight();
            var header_height = $(".site-header-container").outerHeight();
            var headerc_height = $(".collection-header").outerHeight();
            var hasil_gabungan = announce_height + headerc_height;
            var window_height = $(window).height();
            var hasil_final = window_height - header_height;
            var hasil_mobile_lebih = header_height + headerc_height;
            var hasil_mobile_kurang =
                announce_height + header_height + headerc_height;

            // $(".filter-sticky .panel").css("top", header_height + "px");
            // $(window).scroll(function () {
            //     if ($(window).scrollTop() > hasil_gabungan) {
            //         $(".filter-sticky").addClass("is-sticky");
            //         $(".filter-sticky.is-sticky").css("max-height", hasil_final + "px");
            //         $(".filter-sticky").css(
            //             "top",
            //             header_height + "px"
            //         );
            //     } else {
            //         $(".filter-sticky").removeClass("is-sticky");
            //         $(".filter-sticky").css("max-height", "inherit");
            //         $(".filter-sticky").css(
            //             "top", 0 + "px"
            //         );
            //     }
            // });
        }
    }
    if (is_product) {
        function number_format(amount) {
            // Create our number formatter.
            var formatter = new Intl.NumberFormat("id-ID", {
                maximumFractionDigits: 0,
            });
            return formatter.format(amount); /* $2,500.00 */
        }

        function getCart() {
            jQuery.getJSON("/cart.js", function (cart) {
                document.documentElement.dispatchEvent(
                    new CustomEvent("cart:refresh", {
                        bubbles: true,
                        detail: cart,
                    })
                );
                jQuery(".item-count-badge").html(cart.item_count);
                let cartData = cart.items;
                // console.log(cart.item_count);
                if (cart.item_count > 0) {
                    refreshCart(cart, cartData);
                    // console.log(cartData)
                    jQuery(
                        "#react-cart-container > div > div:first-child p"
                    ).remove();
                    var buttonAtc =
                        `
						<div class="small-6 columns text-right">
							<a href="` +
                        checkout_url +
                        `" id="checkout-button" class="custom-css"><i class="cart-loader fa fa-spinner fa-spin"></i> Checkout →</a>
						</div>
					`;
                    var redeem_voucher = `
						
					`;
                    jQuery(redeem_voucher).prependTo(".cart-action-buttons");
                    if (
                        jQuery(".cart-action-buttons #checkout-button").length <
                        1
                    ) {
                        jQuery(buttonAtc).appendTo(".cart-action-buttons .row");
                    }
                } else {
                    jQuery(
                        "<p>You have no items in your shopping cart.</p>"
                    ).prependTo(
                        "#react-cart-container > div > div:first-child"
                    );
                    jQuery(
                        "#react-cart-container > div > div:first-child table"
                    ).remove();
                    jQuery(".cart-action-buttons #checkout-button").remove();
                }

                jQuery("#checkout-button").click(function () {
                    var hrefna = jQuery(this).attr("href");
                    window.location.href =
                        "https://" + Shopify.shop + "/" + hrefna;
                });
            });
        }

        function refreshCart(cart, cartData) {
            var tampungItem = "";
            $.each(cartData, function (index, value) {
                // console.log(value);
                var pricena = "" + value.final_line_price + "";
                var pricenaFormat = pricena.substring(0, pricena.length - 2);
                // console.log(pricenaFormat)
                // console.log(parseInt(pricenaFormat))
                // console.log(value)
                // tampungItem += `
                // 	<tr>
                // 		<td class="line-item-title">
                // 			${value.title}
                // 			<div class="line-item-operations">
                // 				<button type="button" data-variant-id="${value.variant_id}" data-quantity="${
                //     value.quantity
                // }" class="button change-item">+</button>
                // 				<button type="button" data-variant-id="${value.variant_id}" data-quantity="${
                //     value.quantity
                // }" class="button change-item">-</button>
                // 				<button type="button" data-variant-id="${value.variant_id}" data-quantity="${
                //     value.quantity
                // }" class="button change-item">x</button>
                // 			</div>
                // 		</td>
                // 		<td class="line-item-quantity">x${value.quantity}</td>
                // 		<td class="line-item-currency">Rp.</td>
                // 		<td class="line-item-price">${number_format(parseInt(pricenaFormat))}</td>
                // 	</tr>
                // `;
                // new layout
                tampungItem += `
                    <div class="small-12 article-product-item">
                        <div class="row expanded">
                            <div class="small-4 medium-3 columns">
                                <img src="${value.image}">
                            </div>
                            <div class="small-8 medium-9 columns">
                                <h4 class="product-title">${value.title}</h4>
                                <div class="product-price">Rp. ${number_format(
                                    parseInt(pricenaFormat)
                                )}</div>
                            </div>
                        </div>
                        <div class="row expanded">
                            <div class="small-12 columns">
                                <div class="product-size">${
                                    value.variant_title
                                }</div>
                            </div>
                            <div class="small-4 medium-6 columns line-item-title">
                                <div class="line-item-operations">
                                    <button type="button" class="button change-item" data-variant-id="${
                                        value.variant_id
                                    }" data-quantity="${
                    value.quantity
                }">-</button>
                                    <div class="line-item-quantity product-quantity">${
                                        value.quantity
                                    }</div>
                                    <button type="button" class="button change-item wokwo" data-variant-id="${
                                        value.variant_id
                                    }" data-quantity="${
                    value.quantity
                }">+</button>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            });
            var totalPricena = "" + cart.items_subtotal_price + "";
            var totalPricenaFormat = totalPricena.substring(
                0,
                totalPricena.length - 2
            );
            var bodyCart1 = `
			    <div class="row expanded article-product-container">
                    ${tampungItem}
                </div>
			`;
            var bodyCart2 = `
                ${tampungItem}
			`;
            var footerCart = `
            <div class="row columns">
                <div>
                    <div class="cart-total">Rp. ${number_format(
                        parseInt(totalPricenaFormat)
                    )}</div>
                    <a href="/cart" id="checkout-button" class="button">
                        <i class="cart-loader fa fa-spinner fa-spin"></i>
                        Checkout →
                    </a>
                </div>
                <a class="continue-button">Continue Shopping</a>
                <div class="small-12 columns">
                    <span class="reward-text">
                        <a href="/account?view=member" class="url-redeem-voucher">Click To Redeem Insider Rewards Points</a>
                    </span>
                </div>
            </div>
            `;
            if (
                $("#react-cart-container .article-product-container").length > 0
            ) {
                jQuery("#react-cart-container .article-product-container").html(
                    bodyCart2
                );
                jQuery("#react-cart-container .cart-footer-container").html(
                    footerCart
                );
            } else {
                jQuery(bodyCart1).prependTo("#react-cart-container > div");
                jQuery("#react-cart-container .cart-footer-container").html(
                    footerCart
                );
            }
            jQuery(".change-item").click(function () {
                var idnaItem = jQuery(this).attr("data-variant-id");
                var qty = parseInt(jQuery(this).attr("data-quantity"));
                // console.log(idnaItem, qty);
                var url = "/cart/change.js";
                if (jQuery(this).text() == "+") {
                    qty = 1;
                    url = "/cart/add.js";
                    // console.log(qty);
                } else if (jQuery(this).text() == "-") {
                    qty = qty - 1;
                } else if (jQuery(this).text() == "x") {
                    qty = 0;
                }
                $.ajax({
                    type: "POST",
                    url: url,
                    dataType: "json",
                    data: {
                        id: parseFloat(idnaItem),
                        quantity: qty,
                    },
                })
                    .then((data) => {
                        getCart();
                    })
                    .catch((error) => {
                        // console.error('Error add to cart', error.responseJSON.description);
                        alert(error.responseJSON.description);
                    });
            });
        }
        $(document).on("click", ".continue-button", function () {
            $(".close-button").trigger("click");
        });
        $("#AddToCartForm").submit(function (x) {
            x.preventDefault();
            const idna = $("[name=id]").val();
            const qtyna = $("#productQuantity").val();
            // console.log(idna, qtyna)
            var items = [
                {
                    quantity: qtyna,
                    id: idna,
                },
            ];
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: {
                    quantity: qtyna,
                    id: idna,
                },
            })
                .then((data) => {
                    // console.log("Success:", data);
                    // Now I will do a get to show the itens from cart
                    setTimeout(function () {
                        // console.log(jQuery("#cart-panel.active").length);
                        if (jQuery("#cart-panel.active").length < 1) {
                            $(".cart-button").trigger("click");
                        }
                    }, 400);
                    setTimeout(function () {
                        getCart();
                    }, 400);
                    setTimeout(() => {
                        // console.log(jQuery(".cart-button"));
                        jQuery(".cart-button").trigger("click");
                    }, 5000);
                })
                .catch((error) => {
                    // console.error('Error add to cart', error.responseJSON.description);
                    alert(error.responseJSON.description);
                });
        });
    }
    $(".slide-product-py-slider").slick({
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    });
});

if ($("div#voucher-wrapper").length > 0) {
    let getIdGroup = $("#voucher-wrapper").attr("group");
    let getIdCustomer = $(".get-customer-information").attr("customer-id");
    let currentUrl = window.location.href;
    let getUrlStore = $("#voucher-wrapper").attr("url-shopify");
    let titlePage = $(".get-customer-information").attr("page-title");
    $.ajax({
        type: "POST",
        url: "https://atmos-custom-plugin.devbdd.com/front/display_list_voucher",
        data: {
            id: getIdGroup,
            customerId: getIdCustomer,
            currentUrl: currentUrl,
            url_shopify: getUrlStore,
            titlePage: titlePage,
        },
        success: function (response) {
            $("#voucher-wrapper").append(response);

            if (currentUrl.includes("claim=failed")) {
                $("#voucher-wrapper").prepend(
                    '<div class="voucher-wrappe-failed">Claim voucher failed! , pelase login first </div>'
                );
            }
        },
    });
}
